var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cta"},[_c('div',[_c('p',{staticClass:"eyebrow"},[_vm._v(_vm._s(_vm.$t('cta.eyebrow')))]),_c('h2',[_vm._v(_vm._s(_vm.$t('cta.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('cta.text')))])]),_c('router-link',{staticClass:"button",attrs:{"to":"/contact"}},[_vm._v(_vm._s(_vm.$t('cta.button'))+" "),_c('span',[_vm._v("↗")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }